import { render, staticRenderFns } from "./LmUploadImage.vue?vue&type=template&id=5f3901ba&scoped=true&"
import script from "./LmUploadImage.vue?vue&type=script&lang=js&"
export * from "./LmUploadImage.vue?vue&type=script&lang=js&"
import style0 from "./LmUploadImage.vue?vue&type=style&index=0&id=5f3901ba&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3901ba",
  null
  
)

export default component.exports